import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  StatusChipConfigMap,
} from '../status-chip/status-chip.component';

export interface OptionDropdownItem {
  label: string;
  value: any;
  status?: string;
  amount?: string | number;
  [key: string]: any;
}

@Component({
  selector: 'hospitality-bot-option-dropdown',
  templateUrl: './option-dropdown.component.html',
  styleUrls: ['./option-dropdown.component.scss'],
})
export class OptionDropdownComponent {
  @Input() options: OptionDropdownItem[] = [];
  @Input() value: any;
  @Input() disabled = false;
  @Input() placeholder = 'Select option';
  @Input() panelStyleClass = 'option-dropdown-panel';
  @Input() styleClass = '';
  @Input() appendTo: any = 'body';
  @Input() showStatusChip = true;
  @Input() showAmount = true;
  @Input() statusChipConfig?: StatusChipConfigMap;
  @Input() minWidth = '220px';

  @Output() valueChange = new EventEmitter<any>();
  @Output() onChange = new EventEmitter<any>();
  @Output() onShow = new EventEmitter<void>();
  @Output() onHide = new EventEmitter<void>();

  isOpen = false;

  get dropdownIcon(): string {
    return this.isOpen ? 'pi pi-chevron-up' : 'pi pi-chevron-down';
  }

  handleChange(event: { value: any }): void {
    this.value = event?.value;
    this.valueChange.emit(this.value);
    this.onChange.emit(this.value);
  }

  handleShow(): void {
    this.isOpen = true;
    this.onShow.emit();
  }

  handleHide(): void {
    this.isOpen = false;
    this.onHide.emit();
  }
}
